<template>
  <div id="intro-overlay" class="overlay">
    <step1Alt v-if="currentStep === 1 && directStep === null" @finished="finished"></step1Alt>
  </div>
</template>

<script>
import step1Alt from '@/apps/vendorconsignment/tutorials/step1Alt'

export default {
  components: {
    step1Alt
  },
  data: function () {
    return {
      currentStep: 1,
      directStep: null,
      directStepValue: null
    }
  },
  methods: {
    changeStep (next) {
      this.directStep = null

      let i = 1

      if (!next) i = -1

      this.currentStep = this.currentStep + i
    },
    goToStep (step) {
      this.directStep = step
    },
    finished () {
      this.$emit('finished')
    }
  }
}
</script>

<style lang="scss">
@import '../../../styles/mixins';
@import '../../../styles/variables';
</style>



// WEBPACK FOOTER //
// src/apps/vendorconsignment/tutorials/baseAlt.vue